/**
 * Escapa los caracteres con significado estructural en HTML.
 *
 * Obligatorio para todo valor que se interpole dentro del contenido de un InfoWindow de
 * Google Maps: ese string entra al DOM vía `InfoWindow.setContent()`, así que el navegador
 * lo parsea como HTML. Sin escapar, una observación de conductor con
 * `<img src=x onerror=...>` ejecuta código en la sesión de quien abra el globo.
 */
export function escapeHtml(value: any): string {
  if (value === null || value === undefined) return '';
  // El ampersand va primero: si no, '<' se convertiría en '&lt;' y ese '&' se re-escaparía.
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
